import React, { useEffect, useState } from "react";
import { observer } from "mobx-react";
import { makeApi, URLS } from "Utils/apiURL";
import Utils from "Utils/utils";
import { approvalPopupState } from "./ApprovalPopupState";

/**
 * Banner for the sequence overview page. Shows the count of contacts pending
 * approval; clicking opens the ApprovalPopup.
 *
 * Drop into the sequence overview render with: <AwaitingApprovalBanner sequenceId={sequenceId} />
 */
const AwaitingApprovalBanner = observer(({ sequenceId }) => {
  // Self-gate: don't fetch or render if the team doesn't have sequence DR enabled.
  // Self-gating means callers don't need to know about the feature flag.
  const drFeatureOn = Utils.isSequenceDRFeatureEnabled();

  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!sequenceId || !drFeatureOn) return;
    let cancelled = false;
    setLoading(true);
    makeApi({
      url: URLS.drsSequenceAwaitingApprovalContacts.replace("{sequenceId}", sequenceId),
      method: "GET"
    })
      .then(res => {
        if (cancelled) return;
        setCount(res?.data?.totalCount || 0);
        setLoading(false);
      })
      .catch(() => {
        if (!cancelled) {
          setCount(0);
          setLoading(false);
        }
      });
    return () => { cancelled = true; };
  }, [sequenceId, approvalPopupState.showPopup]);

  if (!drFeatureOn || loading || count === 0) return null;

  return (
    <div className="drApprovalBanner" onClick={() => approvalPopupState.open(sequenceId)}>
      <div className="drApprovalBannerLeft">
        <span className="drApprovalBannerIcon">⏳</span>
        <span className="drApprovalBannerText">
          <strong>{count}</strong> contact{count > 1 ? "s" : ""} awaiting your approval
        </span>
      </div>
      <button className="drApprovalBannerCta">Review →</button>
    </div>
  );
});

export default AwaitingApprovalBanner;
